// extracted by css-extract-rspack-plugin
export default {"root":"root-gnvEvr","siteLink":"siteLink-MthdW8","siteTitle":"siteTitle-rOK6ab","logo":"logo-zjY3Q9","right":"right-GZOQt2"};